import ReactGA from 'react-ga4';

// Initialize Google Analytics with your Measurement ID
export const initGA = () => {
  const measurementId = process.env.REACT_APP_GA_MEASUREMENT_ID;

  if (measurementId) {
    ReactGA.initialize(measurementId);
    console.log('Google Analytics initialized');
  } else {
    console.warn('Google Analytics Measurement ID not found in environment variables');
  }
};

// Track page views
export const trackPageView = (path) => {
  ReactGA.send({ hitType: 'pageview', page: path });
  console.log('Page view tracked:', path);
};

// Track custom events (optional - for tracking button clicks, etc.)
export const trackEvent = (category, action, label = '') => {
  ReactGA.event({
    category,
    action,
    label,
  });
};
